import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Row, Col, Form, Container } from "react-bootstrap";
import { setHeading } from "../../../accounts/account.actions";
import { OrderReportApi, generateAllOrderPDF, generateLoadFormPDF, generateLoadFormCategoryWisePDF, generateOrderPDF } from "./OrderBookingAction";
import { getUserRes } from "../../AddUser/user.actions";
import { GetAreaApi } from "../AddArea/areaAction";
import { isEmpty, sumBy } from "lodash";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import { Stack } from "@mui/material";
import Select from "react-select";
import moment from "moment";
import Button from '@mui/material/Button';
import MaterialTable from "material-table";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";


const OrderBookingReports = (props) => {
  const tableRef = useRef();
  function updateTableQuery() {
    tableRef.current.onQueryChange()
  };
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [bookerId, setBookerId] = useState("");
  const [bookerName, setBookerName] = useState("");
  const [areaName, setAreaName] = useState("");
  const [areaId, setAreaId] = useState("");


  const handleChangeArea = (selectedOption) => {
    setAreaId(selectedOption.value);
    setAreaName(selectedOption.label);
  };
  const AreaListData = !isEmpty(props.areaDataList) && props.areaDataList.map((x) => {
    let data = { value: x._id, label: x.areaName };
    return data;
  });

  const handleChangeBooker = (selectedOption) => {
    setBookerId(selectedOption.value);
    setBookerName(selectedOption.label);
  };
  const filterdUserList = !isEmpty(props.userList) && props.userList.filter((e) => e.role === "booker");
  const BookerList = !isEmpty(filterdUserList) && filterdUserList.map((x) => {
    let data = { value: x._id, label: x.userName };
    return data;
  });

  function GetBookings() {
    props.OrderReportApi({
      areaId: areaId,
      bookerId: bookerId,
      startDate: startDate,
      endDate: endDate
    });
    setAreaName("");
    setAreaId("");
    setBookerId("");
    setBookerName("")
    setStartDate(moment().format("YYYY-MM-DD"))
    setEndDate(moment().format("YYYY-MM-DD"))
  }

  function PrintAll() {
    props.generateAllOrderPDF({
      areaId: areaId,
      bookerId: bookerId,
      startDate: startDate,
      endDate: endDate,
    })
  }

  function PrintloadForm() {
    props.generateLoadFormPDF({
      startDate: startDate,
      endDate: endDate
    })
  }

  function PrintloadFormWithCategory() {
    props.generateLoadFormCategoryWisePDF({
      startDate: startDate,
      endDate: endDate
    })
  }

  useEffect(() => {
    props.setHeading("Order Reports");
    props.GetAreaApi();
    props.getUser()
  }, []);

  return (
    <>
      {props.isFetchingAreaData || props.isFetchingUser ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Start Date *</b></Form.Label>
                <Form.Control
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>End Date *</b></Form.Label>
                <Form.Control
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select DSF *</b></Form.Label>
                <Select
                  isDisabled={isEmpty(BookerList)}
                  value={{ label: bookerName }}
                  placeholder="Select DSF"
                  onChange={handleChangeBooker}
                  options={BookerList}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Area *</b></Form.Label>
                <Select
                  isDisabled={isEmpty(props.areaDataList)}
                  value={{ label: areaName }}
                  placeholder="Select Area"
                  onChange={(e) => { handleChangeArea(e); }}
                  options={AreaListData}
                />
              </Form.Group>
            </Col>
          </Row>

          <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="center" mt={3}>
            <Button
              variant="contained"
              size="medium"
              disabled={isEmpty(bookerId)}
              onClick={GetBookings}
            >
              Get Bookings
            </Button>

            <Button
              variant="contained"
              size="medium"
              disabled={isEmpty(bookerId)}
              onClick={PrintAll}
            >
              Print All
            </Button>

            <Button
              variant="contained"
              size="medium"
              disabled={isEmpty(startDate) || isEmpty(endDate)}
              onClick={PrintloadForm}
            >
              Print Load Form
            </Button>

            <Button
              variant="contained"
              size="medium"
              disabled={isEmpty(startDate) || isEmpty(endDate)}
              onClick={PrintloadFormWithCategory}
            >
              Print Load Form Category Wise
            </Button>
          </Stack>

          <div className="main" hidden={props.tableShow == false ? true : false} >
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label><b>Order Length</b></Form.Label>
                  <Form.Control
                    type="number"
                    disabled
                    placeholder="Order Length"
                    value={isEmpty(props.filterBooking) ? 0 : props.filterBooking.length}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label><b>Total Amount</b></Form.Label>
                  <Form.Control
                    type="number"
                    disabled
                    placeholder="Total Amount"
                    value={isEmpty(props.filterBooking) ? 0 : sumBy(props.filterBooking, "subTotal")}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label><b>Total Discount</b></Form.Label>
                  <Form.Control
                    type="number"
                    disabled
                    placeholder="Total Discount"
                    value={isEmpty(props.filterBooking) ? 0 : sumBy(props.filterBooking, "discount")}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label><b>Net Total</b></Form.Label>
                  <Form.Control
                    type="number"
                    disabled
                    placeholder="Net Total"
                    value={isEmpty(props.filterBooking) ? 0 : sumBy(props.filterBooking, "grandTotal")}
                  />
                </Form.Group>
              </Col>
            </Row>
            <MaterialTable
              tableRef={tableRef}
              style={{ zIndex: 1 }}
              title="Order Booking Details"
              columns={[
                { title: "S.No", field: "number", editable: "never" },
                { title: "Area Name", field: "areaId.areaName", editable: "never", },
                { title: "Shop Name", field: "shopId.shopName", editable: "never", },
                { title: "Date", field: "orderDate", render: (rowData) => moment(rowData.orderDate).format("DD-MM-YYYY"), editable: "never", },
                { title: "DSF", field: "bookerId.userName" },
                { title: "Status", field: "status" },
                { title: "Sub Total", field: "subTotal" },
                { title: "Discount", field: "discount" },
                { title: "Trade Offer", field: "tradeOffer" },
                { title: "Tax Amount", field: "taxAmount" },
                { title: "Grand Total", field: "grandTotal" },
              ]}
              data={props.filterBooking}
              detailPanel={(rowData) => {
                return (
                  <MaterialTable
                    columns={[
                      { title: "Code", field: "code", editable: 'never' },
                      { title: "Product Name", field: "productLabel", editable: 'never' },
                      { title: "Quantity", field: "quantity", },
                      { title: "Product Sale Price", field: "productSellingPrice", editable: 'never' },
                      { title: "Total Sale Amount", render: (rowData) => Number(rowData.quantity) * Number(rowData.productSellingPrice) },
                    ]}
                    data={rowData.items}
                    options={{
                      toolbar: false,
                      search: false,
                      actionsColumnIndex: -1,
                      exportButton: false,
                      exportAllData: false,
                      paging: false,
                      pageSize: 50,
                      emptyRowsWhenPaging: false,
                      pageSizeOptions: [50, 100, 150, 200],
                      headerStyle: {
                        position: "sticky",
                        top: 0,
                        color: "#00BBBB",
                        fontWeight: "550",
                        fontSize: "14px",
                      },
                      rowStyle: (rowData, index) => ({
                        backgroundColor: "#ededed",
                        // fontWeight: rowData.accountType === 1 ? "bold" : "normal",
                        color: "black"
                      }),
                    }}
                  />
                );
              }}
              options={{
                actionsColumnIndex: -1,
                exportButton: true,
                exportAllData: true,
                paging: true,
                pageSize: 50,
                emptyRowsWhenPaging: false,
                pageSizeOptions: [50, 100, 150, 200],
                headerStyle: {
                  position: "sticky",
                  top: 0,
                  color: "#00BBBB",
                  fontWeight: "550",
                  onRowAdd: "none",
                  whiteSpace: 'nowrap',
                },
                rowStyle: {
                  whiteSpace: 'nowrap',
                },
                cellStyle: {
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }
              }}
              actions={[
                {
                  icon: () => <PictureAsPdfIcon />,
                  tooltip: "Generate PDF",
                  onClick: (event, rowData) => {
                    props.generateOrderPDF(rowData);
                  },
                },
              ]}
            />
          </div>

        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    OrderReportApi: (data) => dispatch(OrderReportApi(data)),
    generateAllOrderPDF: (data) => dispatch(generateAllOrderPDF(data)),
    generateLoadFormPDF: (data) => dispatch(generateLoadFormPDF(data)),
    generateLoadFormCategoryWisePDF: (data) => dispatch(generateLoadFormCategoryWisePDF(data)),
    getUser: () => dispatch(getUserRes()),
    GetAreaApi: () => dispatch(GetAreaApi()),
    setHeading: (data) => dispatch(setHeading(data)),
    generateOrderPDF: (data) => dispatch(generateOrderPDF(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isFetchingAreaData: state.AreaReducer.isFetchingAreaData,
  areaDataList: state.AreaReducer.areaDataList,
  isFetchingUser: state.UserReducer.isFetchingUser,
  userList: state.UserReducer.userList,
  tableShow: state.OrderBookingReducer.tableShow,
  filterBooking: state.OrderBookingReducer.filterBooking,
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderBookingReports);